angular.module('lead.activity')
    .component('leadActivities', {
        bindings: {
            leadId: '<',
            onDataLoaded: '&'
        },
        templateUrl: 'app/lead/lead-activities/list.html',
        controller: function ($scope, LeadActivity, LeadActivityService) {
            this.LeadActivityService = LeadActivityService

            this.dateFormat = 'mediumDate';

            this.$onChanges = changes => {
                if (changes.leadId) {
                    this.loadData();
                }
            }

            this.loadData = () => {
                if (!this.leadId) {
                    this.page = emptyPage();
                    this.notifyDataLoaded();
                    return;
                }
                return LeadActivity.table({lead: this.leadId}).$promise.then(page => {
                    this.page = page;
                    this.notifyDataLoaded();
                });
            }

            this.notifyDataLoaded = () => {
                if (angular.isFunction(this.onDataLoaded)) {
                    this.onDataLoaded({$page: this.page});
                }
            }

            this.openActivity = id => LeadActivityService.show(id);

            this.switchDateFormat = () => {
                this.dateFormat = this.dateFormat === 'mediumDate' ? 'medium' : 'mediumDate';
            }
            // $scope.$on('comment.date-format.changed', (dateFormat) => this.$onInit());
            $scope.$on('lead.updated', () => this.loadData());
            $scope.$on('lead.deleted', () => this.loadData());
            $scope.$on('lead.activity.updated', () => this.loadData());

            function emptyPage() {
                return {
                    list: [],
                    fullListSize: 0,
                    objectsPerPage: 0,
                    pageNumber: 1
                };
            }
        }
    })
